import { AfterViewChecked, Component, Input, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CommonHelper } from '@app/shared/helpers/common.helper';
import { SidenavMenuConstant } from '@app/constant/sidenav-menu.constant';

@Component({
  selector: 'app-sidenavbar',
  templateUrl: './sidenavbar.component.html',
  styleUrls: ['./sidenavbar.component.scss']
})
export class SidenavbarComponent implements AfterViewChecked {

  @Input() navMenuOpened: Subject<boolean>;
  @ViewChild('sideNavBar') sidenav: MatSidenav;

  menuList = SidenavMenuConstant.sidenavMenu;
  headerChange: boolean = false;

  constructor(private router: Router, private cmHelper: CommonHelper) { }

  ngAfterViewChecked(): void {
    this.menuList.forEach((m: any) => { m.isEnabled = false; m.isDisabled = false; });
    if (['/', '/failure/fdashboard'].includes(this.router.url)) { this.menuList[0].isEnabled = true; }
    if (['/failure/sdashboard'].includes(this.router.url)) { this.menuList[1].isEnabled = true; }
    if (['/failure/fcreation'].includes(this.router.url)) { this.menuList[2].isEnabled = true; }
    if (['/user/ualert'].includes(this.router.url)) { this.menuList[3].isEnabled = true; }
    if (['/admin/amanagement'].includes(this.router.url)) { this.menuList[4].isEnabled = true; }

    this.menuList[2].isDisabled = !sessionStorage.getItem('myim')?.includes('INCIDENT CONTROLLER');
    this.menuList[4].isDisabled = !(['MYIM_ADMIN'].includes(sessionStorage.getItem('myim')));
    this.headerChange = this.cmHelper.changeHeaderHeightURL(this.router.url);
    this.navMenuOpened.subscribe(o => this.sidenav[o ? 'open' : 'close']());
  }

  toggleSidebar(event: any): void {
    this.sidenav.toggle();
    event.stopPropagation();
  }

  navigateToLink(routeLink: any): void {
    this.menuList.forEach(m => { m.isEnabled = m.route === routeLink ? true : false; });
    this.sidenav.close();
    this.router.navigateByUrl(routeLink);
  }

}
